var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FF060A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.79 9.261c-.788-.727-1.877-1.837-2.764-2.625l-.053-.037a1.002 1.002 0 0 0-.291-.162c-2.14-.4-12.096-2.26-12.29-2.237a.368.368 0 0 0-.152.058l-.05.04a.585.585 0 0 0-.137.22l-.013.034v.216c1.12 3.12 5.547 13.345 6.418 15.744.053.162.152.472.339.488h.042c.1 0 .525-.562.525-.562s7.602-9.219 8.37-10.2c.1-.121.188-.251.263-.389a.633.633 0 0 0-.207-.588Zm-6.476 1.074 3.244-2.69 1.904 1.753-5.148.937Zm-1.26-.176L7.468 5.58l9.038 1.667-3.452 2.91Zm.504 1.2 5.717-.922-6.536 7.875.82-6.954ZM6.71 6.037l5.877 4.987-.85 7.292L6.71 6.037Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrx);
export default __webpack_public_path__ + "static/media/trx.fd1af23396a781d7406fc66fe5920572.svg";
export { ForwardRef as ReactComponent };